import React from "react";

import { IQuestionnaire } from "../types/questionnaire";

export type QuestionnaireContextType = {
    questionnaireData: IQuestionnaire | null;
    setQuestionnaireData: React.Dispatch<React.SetStateAction<IQuestionnaire | null>>;
};

const QuestionnaireContext = React.createContext<QuestionnaireContextType | null>(null);

const QuestionnaireProvider = ({ children }: { children: React.ReactNode }) => {
    const [questionnaireData, setQuestionnaireData] = React.useState<IQuestionnaire | null>(null);
    
    return (
        <QuestionnaireContext.Provider value={{questionnaireData, setQuestionnaireData}}>
            {children}
        </QuestionnaireContext.Provider>
    );
}

export default QuestionnaireProvider;

export const useQuestionnaireData = () => {
    const context = React.useContext(QuestionnaireContext);
    if (!context) {
        throw new Error("useQuestionnaire must be used within a QuestionnaireProvider");
    }
    return context;
}